export default (entities) => ({
  getTransaction(id) {
    return entities.Transaction.find(id);
  },
});
